/* eslint no-console:0 */

import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false

require("portal/controllers")
require("global/controllers")

// global JS
import "../global/javascript"

// CSS
import "../portal/css/portal.css"

Rails.start()
